import { Card, Group, Rating, SimpleGrid, Text } from "@mantine/core";
import {
  IconCoin,
  IconDownload,
  IconMessageCircle,
  IconStar,
} from "@tabler/icons-react";
import type { Pricing, Stats } from "./types";
import { formatCurrency } from "./types";

export function StatsCards({
  stats,
  pricing,
}: {
  stats: Stats;
  pricing: Pricing | null;
}) {
  const pricingLabel =
    !pricing || pricing.type === "FREE"
      ? "Free"
      : pricing.type === "SUBSCRIPTION"
        ? `${formatCurrency(pricing.priceAmountCents, pricing.currency)}/mo`
        : formatCurrency(pricing.priceAmountCents, pricing.currency);

  return (
    <SimpleGrid cols={{ base: 1, sm: 4, md: 4 }} spacing="md">
      <Card withBorder padding="md">
        <Group gap="xs" mb={4}>
          <IconDownload size={16} color="gray" />
          <Text size="xs" c="dimmed">
            Installations
          </Text>
        </Group>
        <Text size="xl" fw={700}>
          {stats.totalInstallations}
        </Text>
      </Card>

      <Card withBorder padding="md">
        <Group gap="xs" mb={4}>
          <IconStar size={16} color="gray" />
          <Text size="xs" c="dimmed">
            Avg Rating
          </Text>
        </Group>
        <Group gap="xs">
          <Text size="xl" fw={700}>
            {stats.averageRating?.toFixed(1) ?? "\u2014"}
          </Text>
          {stats.averageRating != null && (
            <Rating
              value={stats.averageRating}
              fractions={2}
              readOnly
              size="sm"
            />
          )}
        </Group>
      </Card>

      <Card withBorder padding="md">
        <Group gap="xs" mb={4}>
          <IconMessageCircle size={16} color="gray" />
          <Text size="xs" c="dimmed">
            Reviews
          </Text>
        </Group>
        <Text size="xl" fw={700}>
          {stats.totalReviews}
        </Text>
      </Card>

      <Card withBorder padding="md">
        <Group gap="xs" mb={4}>
          <IconCoin size={16} color="gray" />
          <Text size="xs" c="dimmed">
            Pricing
          </Text>
        </Group>
        <Text size="xl" fw={700}>
          {pricingLabel}
        </Text>
      </Card>
    </SimpleGrid>
  );
}
